import React from "react";
import Box from "@mui/material/Box";
import { IconButton, Menu, MenuItem } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import {useTheme} from "../../contexts/theme";

interface StyledMenuProps {
    options: string[] | MenuOption[];
    icon?: React.ReactNode;
    anchorEl: null | HTMLElement;
    open: boolean;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    onClose: () => void;
    onClickItem: (item: MenuOption | string) => void;
}

export interface MenuOption{
    icon?: React.ReactNode;
    label: string;
}



const StyledMenu: React.FC<StyledMenuProps> = ({
                                                   options,
                                                   onClickItem,
                                                   anchorEl,
                                                   open,
                                                   onClick,
                                                   onClose,
                                               }) => {
    const ITEM_HEIGHT = 48;
    const theme = useTheme();
    return (
        <Box>
            <IconButton
                aria-label="menu"
                id="menu-button"
                aria-controls={open ? "menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={onClick}
            >
                <SettingsIcon sx={{
                    color: theme.palette.white,
                }}/>
            </IconButton>

            <Menu
                id="menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => onClose()}
                slotProps={{
                    paper: {
                        sx: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: "20ch",
                            bgcolor: theme.palette.blue,
                            color: theme.palette.white,
                        },
                    },
                }}
            >
                {options.map((option) => (
                    <MenuItem key={typeof option === "string" ? option : option.label} onClick={(event) => onClickItem(option)}>
                        {typeof option === "string" ? option :
                            <Box width={'100%'} display={'flex'} alignItems={'center'} gap={theme.spacing.xs}>
                                {option.icon}
                                {option.label}
                            </Box>
                        }
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default StyledMenu;
